import { render, staticRenderFns } from "./uploadsnCom.vue?vue&type=template&id=26bea171&scoped=true&"
import script from "./uploadsnCom.vue?vue&type=script&lang=js&"
export * from "./uploadsnCom.vue?vue&type=script&lang=js&"
import style0 from "./uploadsnCom.vue?vue&type=style&index=0&id=26bea171&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26bea171",
  null
  
)

component.options.__file = "uploadsnCom.vue"
export default component.exports